export const downloadBlobFile = (blob, filename, revokeTimeout = 0) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, revokeTimeout);
  }
};

export const downloadFromUrl = (downloadUrl, fileName = '', newTab = false) => {
  const a = document.createElement('a');
  a.style.display = 'none'
  a.setAttribute('href', downloadUrl);
  a.setAttribute('download', fileName);

  if (newTab) {
    a.setAttribute('target', '_blank');
  }

  document.body.appendChild(a);
  a.click();
  a.remove()
};

export const openFromUrlInNewTab = (url) => {
  const newTab = window.open('', '_blank');

  if (!newTab) {
    // Popup blocked
    alert(
      'Your browser blocked the download popup.\n\n' +
      'Please enable popups for this site and try again.'
    );
    return;
  }

  if (newTab) {
    newTab.document.body.innerHTML = `
      <div style="font-family: sans-serif; padding: 2rem;">
        <h2>Preparing your download...</h2>
        <p>Your file should start downloading automatically.</p>
        <p>If it doesn't, <a href="${url}" download>click here to download</a>.</p>
      </div>
    `;

    // trigger download immediately
    newTab.location.href = url;
  }
};

export const downloadFromRemoteUrl = async (downloadUrl, filename) => {
  try {
    const response = await fetch(downloadUrl);
    const blob = await response.blob();

    downloadBlobFile(blob, filename);
  } catch (error) {
    console.error(`Error downloading file from ${downloadUrl}`, error);

    return error;
  }
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.toString());
    reader.onerror = (error) => reject(error);
  });
};

export const extensionToText = {
  '.pptx': 'PPTX',
  '.ppt': 'PPT',
  '.pdf': 'PDF',
  '.xls': 'Excel',
  '.docx': 'Word',
  '.msg': 'Outlook Message',
  '.otf': 'Font',
  '.jpg': 'Image',
  '.jpeg': 'Image',
  '.png': 'Image',
  '.gif': 'Image',
};

export const compareIdentifiers = (first, second) => {
  const firstType = typeof first;
  const secondType = typeof second;

  if (firstType === secondType) {
    return first === second;
  }

  if (firstType === 'string' && secondType === 'number') {
    return first === second.toString();
  }

  if (firstType === 'number' && secondType === 'string') {
    return first === Number(second);
  }

  return false;
};
